"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapGetOutstandingBalanceResponse = void 0;
const accountManagementUtils_1 = require("./accountManagementUtils");
const urls_1 = __importDefault(require("./urls"));
const mapGetOutstandingBalanceResponse = (_a) => {
    var { response: { has_outstanding_invoices: hasOutstandingInvoices, bill_to_contact_email: billToContactEmail, } } = _a, otherValues = __rest(_a, ["response"]);
    return (Object.assign({ response: {
            hasOutstandingInvoices,
            billToContactEmail,
        } }, otherValues));
};
exports.mapGetOutstandingBalanceResponse = mapGetOutstandingBalanceResponse;
class InvoiceClient {
    getInvoices(params) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = urls_1.default.getInvoices();
            if (params)
                url = (0, accountManagementUtils_1.appendQueryParams)(url, params);
            const response = yield this.requestProtected({
                method: 'GET',
                url,
            });
            return (0, accountManagementUtils_1.mapGetInvoicesResponse)(response);
        });
    }
    downloadInvoice(data) {
        return this.requestProtected({
            method: 'GET',
            url: urls_1.default.downloadInvoice(data.content_document_id),
        });
    }
    toggleInvoiceEmail(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                body: params,
                method: 'POST',
                url: urls_1.default.toggleInvoiceEmail(),
            });
            const { response: { is_email_delivery_on: isEmailDeliveryOn } } = data, otherValues = __rest(data, ["response"]);
            return Object.assign({ response: {
                    isEmailDeliveryOn,
                } }, otherValues);
        });
    }
    getOutstandingBalance() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.outstandingBalance(),
            });
            return (0, exports.mapGetOutstandingBalanceResponse)(response);
        });
    }
    chargeInvoice(data) {
        return this.requestProtected({
            body: data,
            method: 'POST',
            url: urls_1.default.chargeInvoice(),
        });
    }
}
exports.default = InvoiceClient;
